import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const fullLevel = async (params: object) => {
  return await GET({ url: Api.fullLevel, params, showError: false })
}
